export default "__VITE_ASSET__5fJ$GB0Y__"